import React from "react";
import "../styles_css/OurWork.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import rightarrow from "../images/right-arrow.svg";
const OurWork = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const switchLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <div>
      <section class="endless-solutions">
        <h1 class="black-white4"> {t("ourWork.title")}</h1>
        <p class="endless-text">{t("ourWork.description")}</p>
        <a
          className="cta-button2"
          onClick={() => {
            navigate("/"); // Redirect to home
            window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top smoothly
          }}
        >
          <span
            className="button-text"
            style={{ fontSize: "16px", fontWeight: "500" }}
          >
            {t("ourWork.buttonText")}
          </span>
          <span className="button-icon">
            <img src={rightarrow} alt="Arrow Icon" />
          </span>
        </a>
      </section>

      <div className="work">
        <div className="services-grid">
          <div className="services-grid1">
            <div className="service-item one">
              <div className="service-content1">
                <div className="ai">
                  {" "}
                  <p>{t("AI Solutions")}</p>
                </div>

                <div className="wrap">
                  <div className="cont">
                    <div className="cont1">
                      <p>Protecht</p>
                      <img
                        src={require("../images/2024.png")}
                        alt="Protecht Logo"
                        className="company-logo"
                      />
                    </div>
                    <div className="cont2">
                      <p className="gradient">
                        {t("DCS – Data Capture Systems | Strategic Partner")}
                      </p>
                      <div className="cont3">
                      <div 
  className="gradient small" 
  onClick={() => navigate("/projects#project-1")}

>
 {t("seeProjects")}

</div>

                        <div className="arrow-icon"  onClick={() => navigate("/projects#project-1")}
></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="service-item two">
              <div className="service-content1">
                <div className="ai">
                  {" "}
                  <p>{t("Blockchain")}</p>
                </div>

                <div className="conttwo">
                  <div className="cont1">
                    <p>Protecht</p>
                    <img
                      src={require("../images/2024.png")}
                      alt="Protecht Logo"
                      className="company-logo"
                    />
                  </div>
                  <div className="cont2">
                    <p className="gradient small2">
                      {t("DApp and Wallet Development for Blockchain Solutions")}
                    </p>
                    <div className="cont3">
  <div 
    className="gradient small" 
    onClick={() => navigate("/projects#project-2")}
  >
  {t("seeProjects")}

  </div>
  <div 
    className="arrow-icon"  
    onClick={() => navigate("/projects#project-2")}
  ></div>
</div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="services-grid1">
            <div className="service-item three">
              <div className="service-content1">
                <div className="ai">
                  {" "}
                  <p>{t("IT Support and Solutions")}</p>
                </div>

                <div className="conttwo">
                  <div className="cont1">
                    <p>Protecht</p>
                    <img
                      src={require("../images/2024.png")}
                      alt="Protecht Logo"
                      className="company-logo"
                    />
                  </div>
                  <div className="cont2">
                    <p className="gradient small2">
                      {t("Optimizing operations with reliable IT services")}
                    </p>
                    <div className="cont3">
  <div 
    className="gradient small" 
    onClick={() => navigate("/projects#project-3")}
  >
  {t("seeProjects")}

  </div>
  <div 
    className="arrow-icon"  
    onClick={() => navigate("/projects#project-3")}
  ></div>
</div>

                  </div>
                </div>
              </div>
            </div>

            <div className="service-item four">
              <div className="service-content1">
                <div className="ai">
                  {" "}
                  <p>{t("Custom Made Web Applications")}</p>
                </div>

                <div className="wrap">
                  <div className="cont">
                    <div className="cont1">
                      <p>Ritex</p>
                     <img
                      src={require("../images/2024.png")}
                      alt="Protecht Logo"
                      className="company-logo"
                    />
                    </div>
                    <div className="cont2">
                      <p className="gradient ">
                        Ritex.app | Custom-Made CRM System Developed by
                        Protecht.ch
                      </p>
                      <div className="cont3">
                      <div 
  className="gradient small" 
onClick={() => navigate("/projects#project-4")}



>
{t("seeProjects")}

</div>

                        <div className="arrow-icon"  onClick={() => navigate("/projects#project-4")}

></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurWork;
